import axios from 'axios'
import async from "async";

axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}`;


export async function axiosHandler(params) {
    let { method, url, data, headers, token } = params;
    return new Promise((resolve, reject) => {
        try {
            async.waterfall([
                (callback) => {
                    axios({
                        method,
                        url,
                        data: data ?? null,
                        headers: {
                            Authorization: token
                        }
                    }).then((res) => {
                        callback(null, res);
                    }).catch((err) => {
                        callback(err, null)
                    })
                },
            ], (err, result) => {
                if(err) return reject(err)
                resolve(result);
            })
        }catch(err) {
            reject(err)
        }
    })
}